import { memo } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";

import { Loader, PaginationAction } from "components";

import {
  STATUS_HISTORY_TABLE_COLUMNS,
  ROWS_PER_PAGE_OPTIONS,
  NO_DATA_MESSAGE,
} from "../constants";
import StatusHistoryTableRow from "./StatusHistoryTableRow";

const StatusHistoryTable = ({
  isLoading,
  requests,
  pagination,
  onPageChange,
  onRowsPerPageChange,
  onViewDetails,
}) => {
  let tableBodyContent;

  if (isLoading) {
    tableBodyContent = (
      <TableRow>
        <TableCell colSpan={STATUS_HISTORY_TABLE_COLUMNS.length}>
          <Box
            sx={{
              width: "100%",
              minHeight: "30vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loader />
          </Box>
        </TableCell>
      </TableRow>
    );
  } else if (requests.length > 0) {
    tableBodyContent = requests.map((request) => (
      <StatusHistoryTableRow
        key={request.requestId}
        request={request}
        onViewDetails={onViewDetails}
      />
    ));
  } else {
    tableBodyContent = (
      <TableRow>
        <TableCell
          colSpan={STATUS_HISTORY_TABLE_COLUMNS.length}
          align="center"
          sx={{ py: 6 }}
        >
          <Typography color="text.secondary">{NO_DATA_MESSAGE}</Typography>
        </TableCell>
      </TableRow>
    );
  }
  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflowX: "auto",
        boxShadow: 0,
        border: "1px solid",
        borderColor: "grey.300",
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            {STATUS_HISTORY_TABLE_COLUMNS.map((column, index) => (
              <TableCell key={column || `column-${index}`}>
                <Typography variant="caption" fontWeight={700}>
                  {column}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{tableBodyContent}</TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={STATUS_HISTORY_TABLE_COLUMNS.length}
              count={pagination.totalCount}
              page={pagination.page}
              rowsPerPage={pagination.rowsPerPage}
              rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
              onPageChange={onPageChange}
              onRowsPerPageChange={onRowsPerPageChange}
              ActionsComponent={PaginationAction}
              sx={{ borderBottom: 0 }}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

StatusHistoryTable.propTypes = {
  isLoading: PropTypes.bool,
  requests: PropTypes.arrayOf(PropTypes.object).isRequired,
  pagination: PropTypes.shape({
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
  }).isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  onViewDetails: PropTypes.func.isRequired,
};

export default memo(StatusHistoryTable);
